import React, {Component} from "react";
import {connect} from 'react-redux';
import {slide as Menu} from 'react-burger-menu'
import {NavLink} from "react-router-dom";
import {closeAragUserBurgerMenu, openAragUserBurgerMenu} from "../../actions/general";
import { TOBA_SHORT_TEXT, LEGAL_ADVICE_TEXT, TOBA_PATH} from "../../helpers/variables";

class UserBurgerMenu extends Component {
    showSettings(event) {
        event.preventDefault();
    }

    handleStateChange = (state) => {
        state.isOpen?
            this.props.openAragUserBurgerMenu()
            :
            this.props.closeAragUserBurgerMenu()
    };
    
    render() { 
        let icon = '';
        if(this.props.notificationsIconCount!==undefined && this.props.notificationsIconCount>0)
            icon = <span className="notifications-icon">{this.props.notificationsIconCount}</span>;
        var styles = {
            bmBurgerButton: {
                position: 'absolute',
                width: '36px',
                height: '30px',
                left: '36px',
                top: '36px'
            },
            bmBurgerBars: {
                background: '#373a47'
            },
            bmCrossButton: {
                height: '24px',
                width: '24px'
            },
            bmCross: {
                background: '#bdc3c7'
            },
            bmMenuWrap: {
                zIndex: 3
            },
            bmMenu: {
                background: 'white',
                padding: '2.5em 1.5em 0',
                paddingTop: "4em", 
                fontSize: '1.15em',
                color: 'black',
                zIndex: 4
            },
            bmMorphShape: {
                fill: '#373a47'
            },
            bmItemList: {
                color: '#b8b7ad',
                padding: '0.8em'
            },
            bmOverlay: {
                background: 'rgba(0, 0, 0, 0.3)',
                zIndex: 2
            }
        };
        
        return (
            <Menu styles={ styles } isOpen={this.props.menuOpen} onStateChange={(state) => this.handleStateChange(state)} >
                <NavLink onClick={() => this.props.closeAragUserBurgerMenu()} className="menu-item" id="solicitors"  to={"/solicitors"} >{LEGAL_ADVICE_TEXT}s (ATE)</NavLink>
                <NavLink onClick={() => this.props.closeAragUserBurgerMenu()} className="menu-item" id="brokers" to={"/brokers"} >Brokers (BTE)</NavLink>
                <NavLink onClick={() => this.props.closeAragUserBurgerMenu()} className="menu-item" id="quotes" to={"/quotes"} >Quotes</NavLink>
                <NavLink onClick={() => this.props.closeAragUserBurgerMenu()} className="menu-item" id="application-and-policies" to={"/application-and-policies"} >Applications & Policies</NavLink>
                <NavLink onClick={() => this.props.closeAragUserBurgerMenu()} className="menu-item" id="notifications" to={"/notifications"} >Notifications {icon}</NavLink>
                <NavLink onClick={() => this.props.closeAragUserBurgerMenu()} className="menu-item" id="advance-disbursements" to={"/advance-disbursements"} >Advance Disbursements</NavLink>
                <NavLink  onClick={() => this.props.closeAragUserBurgerMenu()} className="menu-item" id="/editing-settings" to={"/editing-settings"} >Editing Settings</NavLink>
                {
                    this.props.allowedToEditReferralSettings?
                        <NavLink  onClick={() => this.props.closeAragUserBurgerMenu()} className="menu-item" id="app-form-referral-settings" to={"/app-form-referral-settings"} >Referral Settings</NavLink>
                        :
                        null

                }
                {
                    this.props.allowedToEditPremiumSettings?
                        <NavLink  onClick={() => this.props.closeAragUserBurgerMenu()} className="menu-item" id="premium-settings" to={"/premium-settings"} >Premium Settings</NavLink>
                        :
                        null

                }
                {
                    this.props.allowedToEditArticles?
                        <NavLink  onClick={() => this.props.closeAragUserBurgerMenu()} className="menu-item" id="articles" to={"/articles"} >Articles</NavLink>
                        :
                        null

                }
                {
                    this.props.allowedToEditTobas?
                        <NavLink  onClick={() => this.props.closeAragUserBurgerMenu()} className="menu-item" id="tobas" to={`/solicitors/${TOBA_PATH}s`} >{`${TOBA_SHORT_TEXT}s`}</NavLink>
                        :
                        null

                }
                <NavLink  onClick={() => this.props.closeAragUserBurgerMenu()} className="menu-item"
                          id="manage-user-account" to={"/manage-user-account"} >Manage Account</NavLink>
                <NavLink onClick={(e)=>{e.preventDefault();this.props.logout();this.props.closeAragUserBurgerMenu()}} className="menu-item" id="logoff" to={"#"} >Log off</NavLink>
                {/*<a onClick={ this.showSettings } className="menu-item--small" href="">Settings</a>*/}
            </Menu>
        );
    }
};

const mapStateToProps = (state) => {
    return {
        notificationsIconCount: state.notifications.notificationsIconCount,
        //arag user page restrictions
        allowedToEditOtherApplications: state.user.loggedInUser.allowedToEditOtherApplications?state.user.loggedInUser.allowedToEditOtherApplications:false,
        allowedToEditPremiumSettings: state.user.loggedInUser.allowedToEditPremiumSettings?state.user.loggedInUser.allowedToEditPremiumSettings:false,
        allowedToEditReferralSettings: state.user.loggedInUser.allowedToEditReferralSettings?state.user.loggedInUser.allowedToEditReferralSettings:false,
        allowedToEditTobas: state.user.loggedInUser.allowedToEditTobas?state.user.loggedInUser.allowedToEditTobas:false,
        allowedToEditArticles: state.user.loggedInUser.allowedToEditArticles?state.user.loggedInUser.allowedToEditArticles:false,

        menuOpen: state.general.aragUserBurgerMenuOpen
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        openAragUserBurgerMenu: (payload) => {
            dispatch(openAragUserBurgerMenu(payload))
        },
        closeAragUserBurgerMenu: (payload) => {
            dispatch(closeAragUserBurgerMenu(payload))
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(UserBurgerMenu);

